import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import TermSheetDocumentGeneralTermsPageUI from './TermSheetDocumentGeneralTermsPageUI.js'

class TermSheetDocumentGeneralTermsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      scheduleRowList: null,
    }
  }

  render() {
    return (
      <TermSheetDocumentGeneralTermsPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        scheduleRowList={this.state.scheduleRowList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getScheduleRows(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getScheduleRows(context) {
    const loanId = this.props.match.params.loanId
    const cacheManager = new CacheManager({
      resource: `/api/su/loans/${loanId}/termSheet/scheduleRows`,
      cacheKey: CacheKeys.TermSheetScheduleRows(loanId),
      callback: this.getScheduleRowsCallback,
      ttlInSecs: 600,
    })
    cacheManager.getObject2(context, null, {
    })
  }

  getScheduleRowsCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      scheduleRowList: response.scheduleRowList || [],
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    const loanId = this.props.match.params.loanId
    CacheManager.removeObject(CacheKeys.TermSheetScheduleRows(loanId))
    if (noBusy === 'noBusy') {
      this.getScheduleRows(context)
    } else {
      CacheManager.removeObject(CacheKeys.Loan(loanId))
      this.setState({
        scheduleRowList: null,
      })
      this.getLoan(context)
      this.getScheduleRows(context)
    }
  }
}

export default withRouter(TermSheetDocumentGeneralTermsPageSF)
